import axios from "axios";
import store from "../../../index"
import { searchResultApi, reserveApi, vacancyOverviewApi, requestReserveApi, apiKeyCheck } from "../../../const/";
import createHistory from 'history/createBrowserHistory';

const history = createHistory();

class Common {
    doPost = (url, param, afterFunc, errorFunc) => {

        if (url === searchResultApi || url === reserveApi
            || url === vacancyOverviewApi || url === requestReserveApi) {
            // APIキーチェック実施
            let state = store.getState().login;
            let apiKey = null;
            if (Object.keys(state).length !== 0) {
                apiKey = state.apiKey;
            }
            if (apiKey === null) {
                store.dispatch({ type: "CLEAR_STATE" });
                history.push("/reserve/login");
            }
            if (apiKey) {
                this.doPost(apiKeyCheck, { apikey: apiKey }, this.afterApiKeyCheck);
            }
        }
        axios.post(url, param).then((res) => {
            afterFunc(res);
        }).catch((err) => {
            if (errorFunc) {
                errorFunc();
            }
            console.log(err);
        })
    }

    doGet = (url, param, afterFunc, errorFunc) => {
        axios.get(url, {
            withCredentials: true,
            auth: {
                username: "rtg",
                password: "Aex7LahC",
            }
        }).then((res) => {
            afterFunc(res);
        }).catch((err) => {
            if (errorFunc) {
                errorFunc();
            }
            console.log(err);
        })
    }

    // APIキーチェック後処理
    afterApiKeyCheck = (res) => {
        if (!res.data) {
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }

    scrollWindow = (elem) => {
        let element = document.getElementById(elem);
        if (element != null) {
            let rect = element.getBoundingClientRect();
            let elemtop = rect.top + window.pageYOffset - 80;

            window.scroll({
                top: elemtop, // スクロール量の設定
                behavior: 'smooth' // スクロール動作の設定
            });
        }
    }
    scrollWindowTop = () => {
        window.scrollTo(0, 0);
    }
    versionCheck = (dbver) => {
        try {
            let versionStorage = "";
            versionStorage = store.getState().version;
            console.log("strageVer" + versionStorage);
            //DBのバージョン
            const versionSource = dbver;
            console.log("sourceVer" + versionSource);
            if (versionSource != versionStorage) {
                //store,storage初期化
                store.dispatch({ type: "CLEAR_STATE" });
                return true;
            }
            else {
                return false;
            }
        }
        catch (e) {
            console.log(e.message);
            return false;
        }
    }

    logout = () => {
        store.dispatch({ type: "CLEAR_STATE" });
    }
}


export default new Common();